import { createFileRoute } from "@tanstack/react-router";
import PrivatePackageSelection from "@/pages/PrivatePackageSelection";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/vinde-masina/pachet/$listingId/")({
  head: ({ params }) => routeHead("/uk/vinde-masina/pachet/$listingId/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivatePackageSelection />
  );
}
